import { render } from "./Kanban.vue?vue&type=template&id=faf1e908"
import script from "./Kanban.vue?vue&type=script&lang=js"
export * from "./Kanban.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__